module.exports = __webpack_public_path__ + "img/bg_video4.2c2b4203.png";